"use client";

import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import type { Dictionary } from "./dictionaries/get-dictionary";

export type ErrorPageTranslations = Dictionary["errorPage"];

const ErrorPageTranslationsContext =
  createContext<ErrorPageTranslations | null>(null);

export type ErrorPageTranslationsProviderProps = {
  errorPageTranslations: ErrorPageTranslations;
  children: ReactNode;
};

export function ErrorPageTranslationsProvider(
  props: ErrorPageTranslationsProviderProps
) {
  return (
    <ErrorPageTranslationsContext.Provider value={props.errorPageTranslations}>
      {props.children}
    </ErrorPageTranslationsContext.Provider>
  );
}

/**
 * Hook to access error page translations in client components like error.tsx
 *
 * @example
 * const errorTranslations = useErrorPageTranslations();
 * const title = errorTranslations.subHeading500;
 */
export function useErrorPageTranslations(): ErrorPageTranslations {
  const context = useContext(ErrorPageTranslationsContext);

  if (!context) {
    throw new Error(
      "useErrorPageTranslations must be used within an ErrorPageTranslationsProvider. " +
        "Make sure your error component is wrapped with the provider in your layout."
    );
  }

  return context;
}
